import { render, staticRenderFns } from "./hotelMouldePage.vue?vue&type=template&id=e821113e"
import script from "./hotelMouldePage.vue?vue&type=script&lang=js"
export * from "./hotelMouldePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports